import { request } from "/src/utils/index.js";

// 获取订单列表
export function GetOrderList(params) {
  return request.get("/sdbs/salesOrder/mall/list", { params });
}

// 获取订单详情
export function GetOrderDetail(params) {
  return request.get("/sdbs/salesOrder/mall/detail", { params });
}

export function ExecuteOperation(data) {
  return request.post("/sdbs/salesOrder/operation/perform", data);
}

export function GetOperationHistory(params) {
  return request.get("/sdbs/salesOrder/operation/history", { params });
}

export function GetAvailableOperations(params) {
  return request.get("/sdbs/salesOrder/operation/list", { params });
}

export function UpdateOrderAddress(data) {
  return request.put("/sdbs/salesOrder/mall/express", data);
}

export function GetAfterSalesOperations(params) {
  return request.get("/sdbs/salesOrder/after/sales/operation/list", { params });
}

export function ExecuteAfterSalesOperation(data) {
  return request.post("/sdbs/salesOrder/after/sales/operation/perform", data);
}

export function GetAfterSalesDetail(params) {
  return request.get("/sdbs/salesOrder/mall/detail", { params }); 
}
